"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("../../styles");
const NoResultsBody = (props) => {
    const { numColumns, isFiltered = false, noResultsMessage } = props;
    return (react_1.default.createElement("tbody", null,
        react_1.default.createElement(styles_1.StyledBodyRow, { disableHoverStyles: true },
            react_1.default.createElement(styles_1.StyledNoResultsCell, { colSpan: numColumns }, typeof noResultsMessage === 'string'
                ? noResultsMessage
                : noResultsMessage(isFiltered)))));
};
exports.default = NoResultsBody;
//# sourceMappingURL=NoResultsBody.js.map